<template>
<div class="chapter">
<div class="inner_page">
<p class="left"><a id="page_ii"></a><a id="fm001"></a><strong>Previous books by Margaret J. Wheatley</strong></p>
<p class="leftt">Turning to One Another</p>
<p class="left">A Simpler Way (with Myron Kellner-Rogers)</p>
<p class="left">Leadership and the New Science</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm001.vue?5a0a8850